// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Bhutan */
const BT = /^(?:(?:1[67]|[78]7)\d{6})$/;

export default BT;
